var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.462,
    height: 19.2,
    viewBox: "0 0 29.462 15.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15958",
    "data-name": "Group 15958",
    transform: "translate(-168.138 -27.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15955",
    "data-name": "Group 15955",
    transform: "translate(149 -14)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 18,
    transform: "translate(30 42)",
    fill: "none",
    stroke: "Black",
    strokeLinecap: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 18,
    transform: "translate(30 49)",
    fill: "none",
    stroke: "Black",
    strokeLinecap: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x2: 18,
    transform: "translate(30 56)",
    fill: "none",
    stroke: "Black",
    strokeLinecap: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9996",
    "data-name": "Path 9996",
    d: "M774.228,261.336l3.906-3.877,3.728,4",
    transform: "translate(-88.46 812.679) rotate(-90)",
    fill: "none",
    stroke: "black",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.04111abe5b745a128b80d73e2ca4f5e5.svg";
export { ForwardRef as ReactComponent };